
    import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
    import OtpVerificationForm from '@/app/settings/components/otp-verification-form.vue'
    import LockoutOverlay from '@/app/settings/components/lockout-overlay.vue'
    import TwoFactorActionFooter from '@/app/settings/components/twofactor-action-footer.vue'
    import ResendCodeLink from '@/app/common/components/resend-code-link.vue'
    import { AddressStyleTranslationMixin } from '@/app/common/helpers/address-style-translation'

    @Component({
        components: {
            OtpVerificationForm,
            LockoutOverlay,
            TwoFactorActionFooter,
            ResendCodeLink
        },
        mixins: [AddressStyleTranslationMixin]
    })
    export default class EmailSetupStepper extends Vue {
        @Prop({ type: Number, default: 1 }) step!: number
        @Prop({ type: Boolean, default: false }) loading!: boolean
        @Prop({ type: String, default: '' }) maskedEmail!: string
        @Prop({ type: String, default: '' }) consumerMaskedEmail!: string
        @Prop({ type: Array, default: () => ['', '', '', '', '', ''] }) value!: string[]

        get otpDigits(): string[] {
            return this.value
        }

        set otpDigits(val: string[]) {
            this.$emit('input', val)
        }

        get otpComplete(): boolean {
            return this.otpDigits.every(digit => digit !== '') && this.otpDigits.length === 6
        }

        @Prop({ type: String, default: '' }) codeError!: string
        @Prop({ type: Boolean, default: false }) codeErrorActive!: boolean
        @Prop({ type: Number, default: 3 }) attemptsRemaining!: number
        @Prop({ type: Number, default: 4 }) maxAttempts!: number
        @Prop({ type: Boolean, default: false }) isLockedOut!: boolean
        @Prop({ type: Boolean, default: false }) rateLimited!: boolean
        @Prop({ type: Number, default: 0 }) lockoutCountdown!: number
        @Prop({ type: Number, default: 0 }) lockoutDuration!: number
        @Prop({ type: Number, default: 0 }) rateLimitCountdown!: number
        @Prop({ type: Number, default: 0 }) rateLimitDuration!: number
        @Prop({ type: Boolean, default: false }) resending!: boolean
        @Prop({ type: Boolean, default: false }) noEmailError!: boolean
        @Prop({ type: String, default: '' }) noEmailMessage!: string

        currentStep = 1

        @Watch('step')
        onStepChange(newStep: number) {
            this.currentStep = newStep
        }

        @Watch('currentStep')
        onCurrentStepChange(newStep: number) {
            this.$emit('update:step', newStep)
            if (newStep === 2 && !this.isLockedOut && !this.rateLimited) {
                // Delay focus until after stepper transition animation completes
                setTimeout(() => {
                    const otpVerificationForm = this.$refs.otpVerificationForm as OtpVerificationForm
                    if (otpVerificationForm && otpVerificationForm.focus) {
                        otpVerificationForm.focus()
                    }
                }, 350)
            }
        }

        mounted() {
            this.currentStep = this.step
        }

        focus(): void {
            const otpVerificationForm = this.$refs.otpVerificationForm as OtpVerificationForm | undefined
            if (otpVerificationForm) {
                otpVerificationForm.focus()
            }
        }

        /**
         * Start the resend cooldown timer
         * Called by parent after successful resend
         */
        startResendCooldown(): void {
            const resendCodeLink = this.$refs.resendCodeLink as ResendCodeLink
            if (resendCodeLink) {
                resendCodeLink.startCooldown()
            }
        }
    }
